<template>
    <div>
        <div style="width: 100%; height: 100%">
            <img src="../assets/img/myqb.jpg" alt="foot" width="100%" />
        </div>
    </div>
</template>

<script>
export default {
    name: "home",
    data() {
        return {};
    },
};
</script>

<style scoped>
a {
    color: black;
    text-underline: none;
}
</style>
